import { render, staticRenderFns } from "./addIntegralRuleFee.vue?vue&type=template&id=a27f3328"
import script from "./addIntegralRuleFee.vue?vue&type=script&lang=js"
export * from "./addIntegralRuleFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports